export default __webpack_public_path__ + "static/media/undraw_Questions_re_1fy7.fd991329.svg";